<p-columnFilter matchMode="equals" showClearButton="false" showMatchModes="false" type="date" [field]="field"
  showMenu="false">
  <ng-template pTemplate="filter">
    <p-datepicker [formControl]="control" [dateFormat]=" 'dd/mm/yy'" size="small" showIcon iconDisplay="input"
      placeholder="Fecha" [showClear]="false" class="custom-input" (onSelect)="filterInput($event)" appendTo="body" />
  </ng-template>
</p-columnFilter>